import { AuthApi } from '@/openapi';
import { createAuthenticatedApiClient } from './api-client';
import React from 'react';
import ReactDOM from 'react-dom';
import AuthMethodAlert from '../components/AuthMethodAlert/AuthMethodAlert.jsx';

/**
 * Validates that the current user's authentication method is allowed
 * Should be called immediately after successful Cognito login
 * @returns {Promise<boolean>} true if validation passed, false if failed
 */
export const validateAuthMethod = async () => {

    try {
        const authApi = createAuthenticatedApiClient(AuthApi);
        await authApi.validateLogin();
        console.log("validateLogin success");

        // Validation passed
        return true;
    } catch (error) {
        // Check if this is an auth method restriction error
        if (error?.response?.status === 403) {
            return false;
        }

        // For other errors, log but allow login to proceed
        // (don't block users if validation service is down)
        console.error('Auth method validation failed:', error);
        return true; // Fail open for resilience
    }
};

export const showAuthMethodError = () => {
    const alertContainer = document.createElement('div');
    alertContainer.id = 'auth-method-alert-root';
    document.body.appendChild(alertContainer);

    ReactDOM.render(
        <AuthMethodAlert />,
        alertContainer
    );
}

